import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius3, colorBgBase, colorBgPrimaryMediumLight, space4, space6 } = theme();

  return StyleSheet.create({
    list: {
      backgroundColor: colorBgBase,
      flexGrow: 0,
      padding: space6,
    },
    rounded: {
      borderRadius: borderRadius3,
    },
    separator: {
      backgroundColor: colorBgPrimaryMediumLight,
      marginVertical: space4,
    },
    title: {
      marginVertical: space4,
    },
  });
};

export { style };
